import { render } from "./BaseInfoTooltip.vue?vue&type=template&id=ec093c60&scoped=true"
import script from "./BaseInfoTooltip.vue?vue&type=script&lang=js"
export * from "./BaseInfoTooltip.vue?vue&type=script&lang=js"

import "./BaseInfoTooltip.vue?vue&type=style&index=0&id=ec093c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec093c60"]])

export default __exports__